import React from "react";

/**
 * Campo de texto con etiqueta arriba y subrayado, no caja.
 * El subrayado se engrosa y toma el color de acento al enfocar.
 */
export default function TextField({
  id,
  label,
  type = "text",
  value,
  onChange,
  name,
  autoComplete,
  placeholder,
  inputMode,
  autoFocus,
  children,
}) {
  return (
    <div className="auth-field">
      <label className="auth-label" htmlFor={id}>
        {label}
      </label>
      <div className="auth-line">
        <input
          id={id}
          name={name || id}
          type={type}
          className="auth-input"
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          placeholder={placeholder}
          inputMode={inputMode}
          autoFocus={autoFocus}
        />
        {children}
      </div>
    </div>
  );
}
